import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";



export class WorkDeliveryStandardResultApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'work-delivery-standard-result'
  }


    /**
     * 查询绩点统计分页列表（分页）
     * @param pageIndex 
     * @param pageSize 
     * @returns 
     */
    public async getGpaStatisticsPageList(pageIndex:number, pageSize:number, data: Object){
        return this.send(data, `getGpaStatisticsPageList?pageIndex=${pageIndex}&pageSize=${pageSize}`, this.Methods.POST);
    }

}
